import { auth, getAppCheckHeader } from "@/main";
import axios from "@/axios";

const endpoint = `${process.env.VUE_APP_BASEURL}/api/genai/chat`;

const Chat = (businessId, chatId, callback) => {
  const controller = new AbortController()
  return {
    prompt: async (prompt, files = []) => {
      const token = await auth.currentUser.getIdToken();
      const formData = new FormData()
      formData.append('input', prompt)
      if (chatId) formData.append('chatId', chatId)
      if (files.length) {
        for (const file of files) {
          formData.append('files', file)
        }
      }

      try {
        const headers = {
          Authorization: `Bearer ${token}`,
          ...(await getAppCheckHeader()),
        };

        const response = await fetch(`${endpoint}/business/${businessId}`, {
          method: 'POST',
          signal: controller.signal,
          headers,
          body: formData,
        });
        chatId = response.headers.get('x-chat-id')
        if (!response.ok) 
          throw "An error occurred please click “View Profile” and reopen a chat or refresh the page.";

        const reader = response.body.getReader()
        const decoder = new TextDecoder("utf-8")

        for (;;) {
          const { done, value } = await reader.read()
          if (done) break
          const chunk = decoder.decode(value)
          callback(chunk)
        }
      } catch (error) {
        throw "An error occurred please click “View Profile” and reopen a chat or refresh the page.";
      }
    },
    close: () => {
      controller.abort();
      axios.post(`${endpoint}/${chatId}/close`);
    },
    getMessages: async () => {
      return axios
        .get(`${endpoint}/${chatId}`)
        .then((messages) => messages)
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
  };
};

export default Chat;
